/**
 * @license
 * Copyright 2023 Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { getShadowElement } from '@tylertech/forge-core';
import { CHIP_FIELD_CONSTANTS } from './chip-field-constants';
import { FieldAdapter } from '../field/field-adapter';
export class ChipFieldAdapter extends FieldAdapter {
    constructor(component) {
        super(component);
    }
    initialize() {
        super.initialize(CHIP_FIELD_CONSTANTS.selectors.ROOT);
        this._memberSlot = getShadowElement(this._component, CHIP_FIELD_CONSTANTS.selectors.MEMBER_SLOT);
        this._inputContainerElement = getShadowElement(this._component, CHIP_FIELD_CONSTANTS.selectors.INPUT_CONTAINER);
    }
    addRootListener(type, callback) {
        this._rootElement.addEventListener(type, callback);
    }
    removeRootListener(type, callback) {
        this._rootElement.removeEventListener(type, callback);
    }
    addMemberSlotListener(listener) {
        this._memberSlot.addEventListener('slotchange', listener);
    }
    removeMemberSlotListener(listener) {
        if (this._memberSlot) {
            this._memberSlot.removeEventListener('slotchange', listener);
        }
    }
    addInputContainerListener(type, callback) {
        this._inputContainerElement.addEventListener(type, callback);
    }
    removeInputContainerListener(type, callback) {
        this._inputContainerElement.removeEventListener(type, callback);
    }
    fieldHasValue() {
        const aMemberExists = !!this._component.querySelector(CHIP_FIELD_CONSTANTS.selectors.MEMBER);
        return aMemberExists || super.inputHasValue();
    }
    focusInput() {
        if (!this._inputElement) {
            return;
        }
        this._inputElement.focus();
    }
    getSlottedMemberElements() {
        return this._component.querySelectorAll(CHIP_FIELD_CONSTANTS.selectors.MEMBER);
    }
}
